import { Component, ViewChild } from "@angular/core";
import { ListPageBase } from "../../../shared/components/list-page-base/list-page-base";
import { LaboratoryExaminationMethodListItem } from "../../../shared/models/laboratory/laboratory-examination-method-list-item";
import { AppService } from "../../../app.service";
import { Router } from "@angular/router";
import { LaboratoryExaminationMethodsService } from "../laboratory-examination-methods.service";
import { StatePersistingService } from "../../../shared/services/state-persisting.service";
import { ExportExcelFromGridService } from "../../../shared/services/export-excel-from-grid.service";
import { UserGroupsService } from "../../../shared/services/user-groups.service";
import { UserGroupsEnum } from "../../../shared/enums/user-groups-enum";
import { KeyValueObject } from "../../../shared/models/core/KeyValueObject";
import { GridSettings } from "../../../shared/models/grid/grid-settings";
import { CellClickEvent, GridComponent } from "@progress/kendo-angular-grid";

@Component({
    selector: 'admin-laboratory-examination-method-list',
    templateUrl: './list.page.html',
    styleUrls: ['./list.page.scss']
})
export class LaboratoryExaminationMethodListPage extends ListPageBase<LaboratoryExaminationMethodListItem> {
    
    @ViewChild("examinationMethodsGrid") examinationMethodsGrid: GridComponent;

    private editedRowIndex: number;

    laboratoryUsers: KeyValueObject[] = [];

    public gridSettingsFilter: GridSettings = {
        state: {
            skip: 0,
            take: 100,
            sort: [{ field: 'name', dir: 'asc' }],
            filter: { logic: 'and', filters: [] },
        },
        columnsConfig: [
            {
                orderIndex: 0,
                field: 'name',
                title: 'Наименование',
                filter: 'string',
                filterable: true,
                width: 250,
                hidden: false
            },
            {
                orderIndex: 1,
                field: 'assignedPerformerUserName',
                title: 'Ответственный',
                filter: 'string',
                filterable: true,
                width: 250,
                hidden: false
            }
        ]
    };

    public gridSettings: GridSettings = {
        state: {
            skip: 0,
            take: 100,
            sort: [{ field: 'name', dir: 'asc' }],
            filter: { logic: 'and', filters: [] },
        },
        columnsConfig: [
            {
                orderIndex: 0,
                field: 'name',
                title: 'Наименование',
                filter: 'string',
                filterable: true,
                width: 250,
                hidden: false
            },
            {
                orderIndex: 1,
                field: 'assignedPerformerUserName',
                title: 'Ответственный',
                filter: 'string',
                filterable: true,
                width: 250,
                hidden: false
            }
        ]
    };

    constructor(
        appService: AppService,
        router: Router,
        protected dataService: LaboratoryExaminationMethodsService,
        protected persistingService: StatePersistingService,
        protected exportExcelFromGridService: ExportExcelFromGridService,
        protected userGroupsService: UserGroupsService) 
    {
        super(router, appService, dataService, persistingService, exportExcelFromGridService);
        appService.pageTitle = 'Методы испытаний';
    }

    onListPageInit(): void {
        this.userGroupsService.getUsersByGroup(<number>UserGroupsEnum.laboratoryEmployees).subscribe(resp => {
            this.laboratoryUsers = resp;
        });
    }

    processListItems(items: LaboratoryExaminationMethodListItem[]): void { }
    
    editHandler({ sender, rowIndex }) {
        if (this.editedRowIndex != null) {
            sender.closeRow(this.editedRowIndex);
        }
        
        sender.editRow(rowIndex);
        this.editedRowIndex = rowIndex;
    }

    cancelHandler({ sender, rowIndex }) {
        sender.closeRow(rowIndex);
        this.editedRowIndex = null;
    }

    saveHandler({ sender, rowIndex, dataItem }) {
        this.loading = true;
        this.dataService.updateAssignedUser(dataItem.laboratoryExaminationMethodId, dataItem.assignedPerformerUserId).subscribe(() => {
            sender.closeRow(rowIndex);
            this.editedRowIndex = null;
            this.loadData();
        });
    }
    
    public cellClick(cellClickEvent: CellClickEvent): void {
        if (cellClickEvent.columnIndex <= this.gridSettings.columnsConfig.length) {
            this.router.navigate(['/categories/laboratory-examination-method', cellClickEvent.dataItem.laboratoryExaminationMethodId]);
        }
	}
}